let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3yhAw")).then(() => parcelRequire('7wN2t'));